import {Agreement} from "../../models/agreements/agreement";
import {apiService} from "../api.service";

export class AgreementsService {
    public async getAgreements(): Promise<Agreement[]> {
        return (await apiService.get<Agreement[]>("marketing/agreements")).data;
    }

    public async approveAgreement(id: number): Promise<void> {
        return (await apiService.post<void>("marketing/agreements/" + id + "/approval")).data;
    }

    public async disapproveAgreement(id: number): Promise<void> {
        return (await apiService.delete<void>("marketing/agreements/" + id + "/approval")).data;
    }
}

export const agreementsService = new AgreementsService();